import React from 'react';
import { useParams } from 'react-router-dom';
import { useTenancy } from '@/contexts/TenancyContext';

// Import original AssetRegister component
import AssetRegister from '../../asset-register';
// Import context provider without UI elements
import AuditorContextProvider from '../components/AuditorContextProvider';

/**
 * Auditor Asset Register - read-only version of the Asset Register
 * This component reuses the original Asset Register component with read-only mode
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorAssetRegister: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { activeTenancy } = useTenancy();

  return (
    <AuditorContextProvider>
      <AssetRegister 
        basePath="/auditor-view/asset-register" 
        isReadOnly={true} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorAssetRegister;
